/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S18_HeadingInputs */

const tr_kullanim_s18_heading = /** @type {(inputs: Kullanim_S18_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18. Muhtelif Hükümler`)
};

const en_kullanim_s18_heading = /** @type {(inputs: Kullanim_S18_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18. Miscellaneous provisions`)
};

const de_kullanim_s18_heading = /** @type {(inputs: Kullanim_S18_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18. Sonstige Bestimmungen`)
};

const ru_kullanim_s18_heading = /** @type {(inputs: Kullanim_S18_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18. Прочие положения`)
};

/**
* | output |
* | --- |
* | "18. Miscellaneous provisions" |
*
* @param {Kullanim_S18_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s18_heading = /** @type {((inputs?: Kullanim_S18_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S18_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s18_heading(inputs)
	if (locale === "de") return de_kullanim_s18_heading(inputs)
	if (locale === "ru") return ru_kullanim_s18_heading(inputs)
	return tr_kullanim_s18_heading(inputs)
});